import React from 'react';
import { Link } from 'gatsby';

import posterImg from '../imgs/tfk-cover.jpg';
 
import coverImg from '../imgs/tfk_background.png';
import logoImg from '../imgs/tfk_logo.png';
import { index as content } from '../content/site';
import { LandingContainer } from '../styles/index.css';
import { GlobalStyle } from '../styles/common.css';

import MainNav from '../components/mainNav';

import Footer from '../components/footer';

function IndexPage() {
  return (
    <>
      <GlobalStyle />
      <LandingContainer>
        <main className="top" role="main">
          <img className="cover" src={coverImg} alt="" />
          <MainNav />
          <div className="main-info drop-down">
            <div className="logo fade-in">
              <img src={logoImg} alt="Totally Funny Kids" />
            </div>
            <h2>{content.launch}</h2>
            <img
              className="abc fade-in"
              src={require('../imgs/cw-logo.png')}
              alt="CW logo"
            />
          </div>
        </main>
        <section className="submit-details">
          <div
            dangerouslySetInnerHTML={{ 
              __html: content.uploadDescriptionHtml
            }}
          />
          <Link className="btn fade-in submit-video" to="/upload">
            Submit a Video
          </Link>
          <p className="warning">{content.uploadWarning}</p>
        </section>

        <section className="video">
          <video width="100%" controls poster={posterImg}>
            <source id="mp4" src="https://d20eudbgldb3n3.cloudfront.net/afvweb/AFV-c1e220f9-fb40-4600-aa01-db47e5a19dc9.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </section>

        <section className="details">
          <div>
            <h1>{content.title}</h1>
            <div
              className="noset"
              dangerouslySetInnerHTML={{
                __html: content.bodyHtml
              }}
            />
            <p>
              <span className="announcement">
                {content.announcement}
              </span>
            </p>
          </div>
          <img
            className="bob fade-in"
            src={require('../imgs/TacarraWilliams_optionB-OPTIMIZED.png')}
            alt="Bob Saget"
          />
        </section>

        <Footer />
      </LandingContainer>
    </>
  );
}

export default IndexPage;
